export class ApiRequestError extends Error {
  readonly code: string;
  readonly status: number;
  readonly requestId: string;
  /**
   * Diagnostic detail that must never be rendered. A schema mismatch carries
   * its issue list here so it stays inspectable in dev tools without the whole
   * dump reaching the advocate, which is what it used to do (D149).
   */
  readonly details: unknown;

  constructor(
    status: number,
    code: string,
    message: string,
    requestId: string,
    details?: unknown,
  ) {
    super(message);
    this.name = "ApiRequestError";
    this.status = status;
    this.code = code;
    this.requestId = requestId;
    this.details = details;
  }
}
